// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stHype_holder_history_chart_container {
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    margin-top: 24px;
    overflow: hidden;
}

.stHype_holder_history_chart_header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--border-color);
}

.stHype_holder_history_chart_header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #002475;
}

.stHype_holder_history_chart_content {
    padding: 16px;
}

.stHype_holder_history_chart_tooltip {
    background-color: var(--card-background-color);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    padding: 8px 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stHype_holder_history_chart_tooltip_date {
    margin: 0;
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
}

.stHype_holder_history_chart_tooltip_value {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #002475;
    font-family: var(--app-font-family);
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .stHype_holder_history_chart_container {
        margin-top: 16px;
    }

    .stHype_holder_history_chart_content {
        padding: 12px;
    }

    .stHype_holder_history_chart_header {
        padding: 12px 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/stHype/staking/uniqueStakerOverTime.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mCAAmC;AACvC;;AAEA,2BAA2B;AAC3B;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".stHype_holder_history_chart_container {\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    margin-top: 24px;\n    overflow: hidden;\n}\n\n.stHype_holder_history_chart_header {\n    padding: 16px 24px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.stHype_holder_history_chart_header h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #002475;\n}\n\n.stHype_holder_history_chart_content {\n    padding: 16px;\n}\n\n.stHype_holder_history_chart_tooltip {\n    background-color: var(--card-background-color);\n    border: 1px solid var(--border-color);\n    border-radius: 4px;\n    padding: 8px 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.stHype_holder_history_chart_tooltip_date {\n    margin: 0;\n    font-size: 12px;\n    color: #666;\n    margin-bottom: 4px;\n}\n\n.stHype_holder_history_chart_tooltip_value {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    color: #002475;\n    font-family: var(--app-font-family);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .stHype_holder_history_chart_container {\n        margin-top: 16px;\n    }\n\n    .stHype_holder_history_chart_content {\n        padding: 12px;\n    }\n\n    .stHype_holder_history_chart_header {\n        padding: 12px 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
